import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';

export const shouldRender = (data: Result['data']) => {
  return data.currentAccount.isUnlimited;
};

export const Component = function UnlimitedAccount() {
  // This should literally render nothing since the account `isUnlimited`.
  return null;
};
